import styled from 'styled-components/macro'
import { theme } from 'styled-tools'

const ProductName = styled.span`
  color: ${theme('productName')};
  word-break: break-word;
`

export default ProductName
